var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[(_vm.isDesktop)?_c('scrollactive',{attrs:{"offset":_vm.navOffset,"active-class":"active","tag":"div"}},_vm._l((_vm.menuPrimary),function(item,index){return _c('v-btn',_vm._b({key:index,staticClass:"anchor-link scrollactive-item",attrs:{"text":""},on:{"click":function($event){return _vm.setOffset(item.offset)}}},'v-btn',item.external ? {
        href: item.link,
        target: '_blank',
        rel: 'noopener noreferrer'
      } : {
        to: _vm.localePath(item.link),
        exact: true
      },false),[_vm._v(_vm._s(_vm.$t('header.' + item.name)))])}),1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }